import { render, staticRenderFns } from "./GroupWalletItem.vue?vue&type=template&id=fa965bac&scoped=true&"
import script from "./GroupWalletItem.vue?vue&type=script&lang=ts&"
export * from "./GroupWalletItem.vue?vue&type=script&lang=ts&"
import style0 from "./GroupWalletItem.vue?vue&type=style&index=0&id=fa965bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa965bac",
  null
  
)

export default component.exports